// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flexBox[data-v-2597e08e] {\n  display: flex;\n  align-items: center;\n}\n.flexBox input[data-v-2597e08e] {\n  margin-right: 10px;\n  display: block;\n}\n.flexBox .ant-checkbox-wrapper[data-v-2597e08e] {\n  flex: 0.5;\n  text-align: right;\n}\n.tips[data-v-2597e08e] {\n  top: 15px;\n  position: absolute;\n  line-height: 18px;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
